import * as ambassadorWixSettingsV1SiteCurrency from './settings-v1-site-currency-site-settings.http.js';
import * as ambassadorWixSettingsV1SiteCurrencyTypes from './settings-v1-site-currency-site-settings.types.js';
import * as ambassadorWixSettingsV1SiteCurrencyUniversalTypes from './settings-v1-site-currency-site-settings.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function setCurrencies(): __PublicMethodMetaInfo<
  'PUT',
  {},
  ambassadorWixSettingsV1SiteCurrencyUniversalTypes.SetCurrenciesRequest,
  ambassadorWixSettingsV1SiteCurrencyTypes.SetCurrenciesRequest,
  ambassadorWixSettingsV1SiteCurrencyUniversalTypes.SetCurrenciesResponse,
  ambassadorWixSettingsV1SiteCurrencyTypes.SetCurrenciesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixSettingsV1SiteCurrency.setCurrencies(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PUT',
    path: '/v1/currencies/site',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getCurrencies(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixSettingsV1SiteCurrencyUniversalTypes.GetCurrenciesRequest,
  ambassadorWixSettingsV1SiteCurrencyTypes.GetCurrenciesRequest,
  ambassadorWixSettingsV1SiteCurrencyUniversalTypes.GetCurrenciesResponse,
  ambassadorWixSettingsV1SiteCurrencyTypes.GetCurrenciesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixSettingsV1SiteCurrency.getCurrencies(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/currencies/site',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  SiteCurrency as SiteCurrencyOriginal,
  SetCurrenciesRequest as SetCurrenciesRequestOriginal,
  SetCurrenciesResponse as SetCurrenciesResponseOriginal,
  GetCurrenciesRequest as GetCurrenciesRequestOriginal,
  GetCurrenciesResponse as GetCurrenciesResponseOriginal,
  SetCheckoutCurrenciesRequest as SetCheckoutCurrenciesRequestOriginal,
  SetCheckoutCurrenciesResponse as SetCheckoutCurrenciesResponseOriginal,
  GetCheckoutCurrenciesRequest as GetCheckoutCurrenciesRequestOriginal,
  GetCheckoutCurrenciesResponse as GetCheckoutCurrenciesResponseOriginal,
} from './settings-v1-site-currency-site-settings.types.js';
